var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-toolbar',{staticClass:"kinostart-toolbar",attrs:{"position":"bottom","no-shadow":"","no-hairline":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('kinostart.' + _vm.kinostart))}})])}
var staticRenderFns = []

export { render, staticRenderFns }